import styled, { css } from "styled-components/native";
import { TextInput } from "react-native-paper";
import MaterialIcon from "@expo/vector-icons/MaterialIcons";

import { Icon } from "~/components/icon";
import { Text2 } from "~/components/text";

import { spacers, fontSizes, lineHeights } from "~/styles/theme";

export const inputStyles = css`
  font-size: 16.5px;
  line-height: 23px;
  color: ${({ theme }) => theme.colors.black};
  fontfamily: "SFPro";
`;

const secondaryText = css`
  margin-top: ${spacers.ss3};
  padding-left: ${spacers.ss5};
  font-family: Roboto;
`;

export const Container = styled.View`
  flex-direction: row;
  margin-vertical: ${spacers.ss3};
`;

export const Input = styled(TextInput)`
  font-size: ${fontSizes.fs3};
  line-height: ${lineHeights.lh3};
  background-color: ${({ theme }) => theme.colors.transparent};
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: -0.4px;
  font-family: SFProDisplay;
  flex: 1;
`;

export const MaskedInputContainer = styled.View`
  padding-top: 19px;
  padding-left: 14px;
`;

export const IconButton = styled.TouchableOpacity`
  margin-top: ${spacers.ss3};
  margin-left: ${spacers.ss4};
  position: absolute;
  bottom: 20px;
  right: 0px;
`;

export const StyledIcon = styled(Icon)<{ isActive: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme?.colors.black : theme?.colors.gray700};
  width: 22px;
  height: 22px;
`;

export const RightIcon = styled(MaterialIcon)`
  color: ${({ theme }) => theme.colors.gray400};
  position: absolute;
  right: 14px;
  top: 14px;
`;

export const ErrorMessage = styled(Text2)`
  color: ${({ theme }) => theme.colors.red500};
  ${secondaryText};
`;

export const HintMessage = styled(Text2)`
  color: ${({ theme }) => theme.colors.gray500};
  ${secondaryText};
  font-size: ${fontSizes.fs1};
  line-height: ${lineHeights.lh2};
`;

export const Overlay = styled.TouchableOpacity`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const InputBox = styled.View`
  background-color: ${({ theme }) => theme.colors.gray100};
  padding: 10px;
  height: 48px;
  justify-content: center;
  border-radius: ${spacers.ss4};
  flex: 1;
  margin-horizontal: ${spacers.ss3};
`;

export const SecondaryBox = styled.View<{ noMargin?: boolean }>`
  background-color: ${({ theme }) => theme.colors.gray75};
  padding: 10px;
  height: 48px;
  border-radius: ${spacers.ss4};
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;

export const StyledTextInput = styled.TextInput`
  padding-horizontal: 0px;
  color: ${({ theme }) => theme.colors.black};
`;

export const EditText = styled(Text2)`
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-size: 13px;
  font-family: SFProDisplayMedium;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const NativeTextInput = styled.TextInput`
  min-width: 240px;
  color: ${({ theme }) => theme.colors.black};
`;
